import FormaEmbed from './Embed';

export default FormaEmbed;
